import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';
import { reducer as formReducer } from 'redux-form';

// Reducers
import auth from 'modules/auth/reducers';
import filters from 'modules/filters/store/reducers';
import layout from 'modules/page-layout/store/reducers';
import modals from 'modules/modals/reducers';
import alerts from 'modules/alerts/reducers';
import timers from 'modules/timers/reducers';
import location from 'modules/history/reducers';
import triage from 'modules/triage/store/reducers';
import pageData from 'modules/page-data/reducers';

import purchases from 'routes/purchases/store/reducers';
import agreements from 'routes/agreement/store/reducers';
import companies from 'routes/company/store/reducers';
import billing from 'routes/billing/store/reducers';
import people from 'routes/person/store/reducers';
import invoices from 'routes/invoice/store/reducers';
import triagePage from 'routes/triage/store/reducers';
import tickets from 'routes/ticket/store/reducers';
import timeReports from 'routes/time-report/store/reducers';

const logger = store => next => action => { // eslint-disable-line no-unused-vars
  console.group(action.type);
  console.info('dispatching', action);
  const result = next(action);
  console.log('next state', store.getState());
  console.groupEnd(action.type);
  return result;
};


export default createStore(
  combineReducers({
    auth,
    filters,
    layout,
    modals,
    alerts,
    timers,
    location,
    triage,
    pageData,
    form: formReducer,
    // Route-specific reducers
    purchases,
    companies,
    billing,
    people,
    invoices,
    agreements,
    triagePage,
    tickets,
    timeReports
  }),
  compose(
    applyMiddleware(thunk),
    // Only enable dev tools if not in production
    process.env.NODE_ENV !== 'production' && window.devToolsExtension ? window.devToolsExtension() : (f) => f
  )
);
